import React from "react";
import { isMobile } from "react-device-detect";
import { useGameContext } from "../../../context/GameContext";
import { SummaryData, SummaryType } from "../../../types";
import { useContent } from "../details/utils";
import InfoCard from "./Card";
import {
	AwardIconWrapper,
	CardContainer,
	Circle1,
	Circle2,
	Container,
	Finish,
	LampIconWrapper,
	Line,
	TagIconWrapper,
	TimeIconWrapper,
	Title,
} from "./styles";

const iconMap = {
	award: <AwardIconWrapper />,
	time: <TimeIconWrapper />,
	lamp: <LampIconWrapper />,
	tag: <TagIconWrapper />,
};

type Props = {
	gameOverContent: any;
};

const summaryLabelMap = {
	[SummaryType.AWARD]: "summaryPlace",
	[SummaryType.TIME]: "summaryTime",
	[SummaryType.LAMP]: "summaryTips",
	[SummaryType.TAG]: "summaryWrongAnswers",
};

const Summary: React.FC<Props> = ({ gameOverContent }) => {
	const { summary } = useGameContext();
	const contentSummaryTitle = useContent({
		contentId: gameOverContent?.summaryTitle,
		defaultId: "GAME_OVER.summary.header",
	});

	return (
		<Container>
			{isMobile && <Finish>{contentSummaryTitle}</Finish>}
			<CardContainer>
				{summary.length > 0 ? (
					<>
						<Line>
							<Circle1 />
							<Circle2 />
						</Line>
						<Title>{contentSummaryTitle}</Title>
						{summary.map((item: SummaryData) => {
							return (
								<InfoCard
									key={item.label}
									data={item.content}
									label={item.label}
									icon={iconMap[item.iconMapper]}
									type={item.type}
									contentId={gameOverContent?.[summaryLabelMap[item.type]]}
								></InfoCard>
							);
						})}
					</>
				) : null}
			</CardContainer>
		</Container>
	);
};

export default Summary;
